import CitySEOHead from "@/components/feature/CitySEOHead";
import VAHeroSection from "./components/HeroSection";
import VACitiesDirectory from "./components/CitiesDirectory";
import VAStateResources from "./components/StateResources";
import VAFAQSection, { faqs } from "./components/FAQSection";
import VAFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function VirginiaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Virginia"
        state="Virginia"
        stateAbbr="VA"
        route="/states/virginia/"
        title="Virginia Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Virginia — Richmond, Arlington, Alexandria, Virginia Beach, Norfolk, Charlottesville, and Northern Virginia. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Virginia, United States"
        geoPosition="37.4316;-78.6569"
        faqs={faqs.map(f => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
      />
      <VAHeroSection />
      <VACitiesDirectory />
      <VAStateResources />
      <VAFAQSection />
      <SEOCrossLinks state="VA" />
      <VAFinalCTA />
    </div>
  );
}